import HttpService from '../services/httpService';

const ESTIMATED_ROW_BYTES = 180;
const CSV_HEADER_BYTES = 120;

export const estimatePanelCsvBytes = (totalCount = 0) => (
    Math.max(Number(totalCount) * ESTIMATED_ROW_BYTES + CSV_HEADER_BYTES, 1)
);

export const getPanelDownloadPercent = (progressEvent, estimatedBytes) => {
    if (!progressEvent) return 0;

    const { loaded, total } = progressEvent;
    if (total) {
        return Math.min(100, Math.round((loaded * 100) / total));
    }

    if (estimatedBytes) {
        return Math.min(99, Math.round((loaded * 100) / estimatedBytes));
    }

    return 0;
};

export const downloadProductionSummaryPanelCsv = async ({
    payload,
    totalCount,
    onProgress,
}) => {
    const estimatedBytes = estimatePanelCsvBytes(totalCount);
    onProgress?.(0);

    const res = await HttpService.downloadProductionSummaryPanelDetails(payload, {
        onDownloadProgress: (progressEvent) => {
            onProgress?.(getPanelDownloadPercent(progressEvent, estimatedBytes));
        },
    });

    onProgress?.(100);
    return res;
};

export const downloadSnagPanelCsv = async ({
    payload,
    totalCount,
    onProgress,
}) => {
    const estimatedBytes = estimatePanelCsvBytes(totalCount);
    onProgress?.(0);

    const res = await HttpService.downloadSnagPanelDetails(payload, {
        onDownloadProgress: (progressEvent) => {
            onProgress?.(getPanelDownloadPercent(progressEvent, estimatedBytes));
        },
    });

    onProgress?.(100);
    return res;
};

export const downloadDeliveryPackagePanelCsv = async ({
    payload,
    totalCount,
    onProgress,
}) => {
    const estimatedBytes = estimatePanelCsvBytes(totalCount);
    onProgress?.(0);

    const res = await HttpService.downloadDeliveryPackagePanelDetails(payload, {
        onDownloadProgress: (progressEvent) => {
            onProgress?.(getPanelDownloadPercent(progressEvent, estimatedBytes));
        },
    });

    onProgress?.(100);
    return res;
};

export const saveCsvBlob = (blobData, fileName) => {
    const blob = new Blob([blobData], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};
